<template>
    <div>
            <div class="d-flex flex-wrap align-center justify-space-between" style="gap: 12px;">
                <h2 class="mb-0">Relatório de Solicitação de Orçamento</h2>
                <v-btn outlined color="primary" @click="$router.push('/relatorios#comercial')">
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar ao menu
                </v-btn>
            </div>
            <v-card class="mt-4" ref="areaPdf">
                <v-card-text>
                    <div class="d-flex flex-wrap align-center mb-4" style="gap: 12px;">
                        <v-text-field
                            v-model="filter.dataInicio"
                            type="date"
                            label="Data início"
                            solo
                            hide-details
                            class="c-filtro"
                            @input="getRelatorioSalesOrder"
                        />
                        <v-text-field
                            v-model="filter.dataFim"
                            type="date"
                            label="Data fim"
                            solo
                            hide-details
                            class="c-filtro"
                            @input="getRelatorioSalesOrder"
                        />
                        <v-autocomplete
                            v-model="filter.codigo"
                            :items="codigoOptions"
                            label="Orçamento"
                            solo
                            hide-details
                            clearable
                            class="c-filtro"
                            @change="getRelatorioSalesOrder"
                        />
                        <v-autocomplete
                            v-model="filter.cliente"
                            :items="clienteOptions"
                            label="Cliente"
                            solo
                            hide-details
                            clearable
                            class="c-filtro"
                            @change="getRelatorioSalesOrder"
                        />

                        <v-btn color="primary" @click="getRelatorioSalesOrder">
                            <v-icon left>mdi-refresh</v-icon>
                            Recarregar
                        </v-btn>

                        <v-menu>
                            <template v-slot:activator="{ on }">
                                <v-btn color="primary" outlined v-on="on">
                                    <v-icon left>mdi-file-export-outline</v-icon>
                                    Exportar
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item
                                    v-for="(item, index) in actions"
                                    :key="index"
                                    :value="index"
                                    @click="item.handle"
                                    class="cursor-pointer"
                                >
                                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                                </v-list-item>
                            </v-list>

                        </v-menu>
                    </div>

            <v-simple-table dense class="w-100 pdf-content">
                <thead>
                    <tr>
                        <th>Orçamento</th>
                        <th>Cliente</th>
                        <th>Projeto</th>
                        <th>Contato</th>
                        <th>Fone</th>
                        <th>Data/Soli</th>
                        <th>Orçamentista</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dado in dadosTabela" :key="dado._id" style="cursor: pointer;">
                        <template v-if="!dado.revisoes">
                            <td>
                                {{ dado.codigo }}
                            </td>
                            <td>
                                {{ dado.clienteNome || "Cliente Não Informado" }}
                            </td>
                            <td>
                                -
                            </td>
                            <td>
                                {{  dado.contatoComercialNome }}
                            </td>

                            <td>
                                {{  dado.contatoComercialTelefone }}
                            </td>
                            <td>
                                {{ new Date(dado.dateGenerate).toLocaleDateString() }}
                            </td>
                            <td>
                                {{ dado.orcamentistaNome }}
                            </td>

                        </template>

                        <template v-else>
                            <td>
                                {{ dado.revisoes.codigo }}
                            </td>
                            <td>
                                {{ dado.revisoes.clienteNome || "Cliente Não Informado" }}
                            </td>
                            <td>
                                -
                            </td>
                            <td>
                                {{  dado.revisoes.contatoComercialNome }}
                            </td>

                            <td>
                                {{  dado.revisoes.contatoComercialTelefone }}
                            </td>
                            <td>
                                {{ new Date(dado.revisoes.dateGenerate).toLocaleDateString() }}
                            </td>
                            <td>
                                {{ dado.revisoes.orcamentistaNome }}
                            </td>
                        </template>

                    </tr>
                </tbody>
            </v-simple-table>
                </v-card-text>
            </v-card>

            <RelatorioResumoComercial 
                :isOpen="openResumoComercial"
                :salesOrderData="dadosTabela"
                @cancel="openResumoComercial = false"
            />
            
    </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment';
import RelatorioResumoComercial from './RelatorioResumoComercial.vue';
import { exportarExcel, exportarPdfTabela } from "@/views/Relatorios/base/relatorioBaseUtils";

export default {
    components: { RelatorioResumoComercial },
    name: 'RelatorioSalesOrderView',
    data() {
        return {
            filter: {
                dataInicio: '',
                dataFim: '',
                codigo: '',
                cliente: '',
                vendedor: '',
                orcamentista: ''
            },
            dadosTabela: [],
            actions: [
                { title: 'Exportar PDF', 
                    handle: this.exportPdf
                },
                { title: 'Exportar Excel', handle: this.exportExcel },
                // { 
                //     title: 'Resumo Comercial', handle: () => {
                //         this.openResumoComercial = true
                //     }
                // }
            ],
            openResumoComercial: false
        };
    },
    computed: {
        codigoOptions() {
            const lista = this.dadosTabela.map((item) => {
                const dados = item?.revisoes || item || {};
                return dados.codigo || '';
            });

            return [...new Set(lista.filter(Boolean))].sort();
        },
        clienteOptions() {
            const lista = this.dadosTabela.map((item) => {
                const dados = item?.revisoes || item || {};
                return dados.clienteNome || '';
            });

            return [...new Set(lista.filter(Boolean))].sort();
        }
    },

    methods: {

        async getRelatorioSalesOrder() {
            const response = await Vue.prototype.$http.post('/View/run', {
                    params: [
                        { dataType: "String", name: "dataInicio", value: this.filter.dataInicio ? moment(this.filter.dataInicio).format('YYYY-MM-DD') : moment('1970-01-01').format('YYYY-MM-DD') },
                        { dataType: "String", name: "dataFim", value: this.filter.dataFim ? moment(this.filter.dataFim).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD') },
                        { dataType: "string", name: "codigo", value: this.filter.codigo },
                        { dataType: "string", name: "cliente", value: this.filter.cliente },
                        { dataType: "string", name: "vendedor", value: this.filter.vendedor },
                        { dataType: "string", name: "orcamentista", value: this.filter.orcamentista },
                        { dataType: "string", name: "order", value: "clienteNome" },
                        { dataType: "Number", name: "desc", value: this.filter.order ? Number(this.filter.order) : 1 }
                    ],
                    viewName: "get-relatorio-sales-order",
                    page: 1,
                    limit: 3000000

            })
            this.dadosTabela = response.data.data.data
        },

        async exportPdf() {
            const linhas = this.dadosTabela.map((item) => {
                const dados = item.revisoes ? item.revisoes : item;

                return {
                    codigo: dados.codigo || '',
                    clienteNome: dados.clienteNome || "Cliente Não Informado",
                    projeto: '-',
                    contatoComercialNome: dados.contatoComercialNome || '',
                    contatoComercialTelefone: dados.contatoComercialTelefone || '',
                    dateGenerate: dados.dateGenerate || null,
                    orcamentistaNome: dados.orcamentistaNome || ''
                };
            });

            await exportarPdfTabela({
                headers: [
                    { text: 'Orçamento', value: 'codigo' },
                    { text: 'Cliente', value: 'clienteNome' },
                    { text: 'Projeto', value: 'projeto' },
                    { text: 'Contato', value: 'contatoComercialNome' },
                    { text: 'Fone', value: 'contatoComercialTelefone' },
                    { text: 'Data/Soli', value: 'dateGenerate' },
                    { text: 'Orçamentista', value: 'orcamentistaNome' }
                ],
                rows: linhas,
                nomeArquivo: 'Relatorio-Solicitacao-Orcamento.pdf',
                tituloRelatorio: 'Relatório de Solicitação de Orçamento',
                formatadoresPorCampo: {
                    dateGenerate: (valor) => valor ? new Date(valor).toLocaleDateString('pt-BR') : '-'
                }
            });
        },

        exportExcel() {
            const dataRelatorio = this.dadosTabela.map((item) => {
                // Se tiver revisões, usa ela, senão usa o item principal
                const dados = item.revisoes ? item.revisoes : item;

                return {
                    'Orçamento': dados.codigo || '',
                    'Cliente': dados.clienteNome || "Cliente Não Informado",
                    'Projeto': '-', // você fixou como "-" na tabela
                    'Contato': dados.contatoComercialNome || '',
                    'Fone': dados.contatoComercialTelefone || '',
                    'Data/Soli': dados.dateGenerate 
                        ? new Date(dados.dateGenerate).toLocaleDateString('pt-BR') 
                        : '',
                    'Orçamentista': dados.orcamentistaNome || ''
                }
            });

            exportarExcel(dataRelatorio, 'Solicitação-Orçamento.xlsx');
        }
    },

    created() {
        this.getRelatorioSalesOrder()
    }
}
</script>

<style scoped>


.pdf-content {
  font-family: 'Arial', sans-serif;
}

.c-filtro {
    min-width: 220px;
    max-width: 280px;
}

/* @media print {
  #conteudoPDF {
    display: block !important;
  }
} */
</style>